module.exports = __webpack_public_path__ + "img/MARQUISE.77d70e88.png";